import {
  Component,
  OnInit
} from '@angular/core';

import {
  ActivatedRoute,
  Router
} from '@angular/router';



import {
  ExtractedIdDetails
} from 'src/app/core/ExtractedIdDetails';
import { XIdentityDocument } from 'src/app/core/XIdentityDocument';
import { XParticipantRegistrationForm } from 'src/app/core/XParticipantRegistrationForm';
import { XQualification } from 'src/app/core/XQualification';
import { XSelectedCourse } from 'src/app/core/XSelectedCourse';
import { XUploadedCertificate } from 'src/app/core/XUploadedCertificate';

import {
  AdminService
} from 'src/app/services/admin/admin.service';
import { CourseService } from 'src/app/services/course/course.service';

import {
  FileUploadService
} from 'src/app/services/file-upload/file-upload.service';



@Component({

  selector:
    'app-x-participant-registration',

  templateUrl:
    './x-participant-registration.component.html',

  styleUrl:
    './x-participant-registration.component.scss'

})
export class XParticipantRegistrationComponent implements OnInit {

  // Store enquiry ID
  enquiryId = 0;

  // Store participant ID
  participantId = 0;


  // Store company name
  companyName = '';

  // Store company email
  companyEmail = '';

  // Store required training date
  dateTrainingRequired:
    string | null =
    null;


  // Store submitted date
  submittedDate =
    new Date()
      .toLocaleDateString(
        'en-CA'
      );


  // Store selected courses
  selectedCourses:
    XSelectedCourse[] =
    [];


  // Store qualification list
  qualificationList:
    XQualification[] =
    [];


  // Store participant details
  participant:
    XParticipantRegistrationForm =
    this.createParticipant();


  // Track loading state
  isLoading = false;

  // Track submission state
  isSubmitting = false;

  // Store error message
  errorMessage = '';

  // Store load error message
  loadErrorMessage = '';

  // Store success message
  successMessage = '';

  // Track submitted state
  alreadySubmitted = false;


  // Track certificate upload count
  private certificateUploadingCount = 0;

  // Store identity types
  identityTypesList: any[] = [];

  // Store registration type
  type: string = '';

  // Store yesterday date
  yesterdayDate: string = '';

  // Store reference prefix
  ReferencePrefix: string = '';

  // Control   success popup visibility
  showSuccessPopup: boolean = false;

  constructor(

    private route:
      ActivatedRoute,

    private adminService:
      AdminService,

    private uploadService:
      FileUploadService,

    private router:
      Router,

    private courseService: CourseService

  ) {
  }


  // Initialise registration details
  ngOnInit(): void {

    // Create yesterday date
    const yesterday = new Date();

    // Set yesterday
    yesterday.setDate(
      yesterday.getDate() - 1
    );

    // Store yesterday date
    this.yesterdayDate =
      yesterday.toISOString().split('T')[0];


    // Get enquiry ID from URL
    const enquiryId =
      Number(
        this.route
          .snapshot
          .queryParamMap
          .get('enquiryId')
      );


    // Get participant ID from URL
    const participantId =
      Number(
        this.route
          .snapshot
          .queryParamMap
          .get('participantId')
      );


    // Get registration type from URL
    const type =
      this.route
        .snapshot
        .queryParamMap
        .get('type')
        ?.toLowerCase()
      ?? '';


    // Validate registration parameters
    if (
      !enquiryId ||
      !participantId
    ) {

      this.loadErrorMessage =
        'Invalid participant registration link.';

      return;
    }


    // Store enquiry ID
    this.enquiryId =
      enquiryId;


    // Store participant ID
    this.participantId =
      participantId;


    // Store registration type
    this.type =
      type;


    // Load qualification list
    this.loadQualificationList();


    // Load participant details
    this.loadParticipantDetails();


    // Load identity types
    this.getIdentityTypes();


    // Load reference prefix
    this.getReferencePrefix();
  }


  // Load reference prefix
  getReferencePrefix(): void {

    // Set reference prefix type
    const prefixType =
      this.type?.toUpperCase() === 'ENQ' ||
        this.type?.toUpperCase() === 'OTHER'
        ? 'ENQUIRY'
        : 'BOOKING';

    this.courseService
      .GetReferencePrefix(
        prefixType
      )
      .subscribe({

        next: (prefix: string) => {

          // Store reference prefix
          this.ReferencePrefix =
            prefix;

        },

        error: (error) => {

          console.error(
            'Error loading reference prefix',
            error
          );

        }
      });
  }


  // Load identity types
  getIdentityTypes(): void {

    this.courseService
      .GetIdentityTypesList()
      .subscribe({

        next: (response: any) => {

          // Store identity types
          this.identityTypesList =
            response || [];

        },

        error: (error: any) => {

          console.error(
            'Error loading identity types',
            error
          );

          // Reset identity types
          this.identityTypesList = [];
        }
      });
  }

  // Load qualification list
  loadQualificationList(): void {

    this.courseService
      .getXQualificationList()
      .subscribe({

        next: (
          response: any[]
        ) => {

          // Store qualification source
          const source =
            response || [];


          // Map qualification list
          this.qualificationList =
            source.map(
              (
                qualification: any
              ) => {

                return {

                  id:
                    Number(
                      qualification?.id
                      ??
                      qualification?.Id
                      ??
                      0
                    ),

                  qualificationName:
                    (
                      qualification?.qualificationName
                      ??
                      qualification?.QualificationName
                      ??
                      ''
                    )
                      .toString()
                      .trim(),

                  qualificationType:
                    (
                      qualification?.qualificationType
                      ??
                      qualification?.QualificationType
                      ??
                      ''
                    )
                      .toString()
                      .trim(),

                  isActive:
                    Boolean(
                      qualification?.isActive
                      ??
                      qualification?.IsActive
                      ??
                      false
                    )
                };

              }
            )
              .filter(
                qualification =>
                  qualification.id > 0
              );
        },


        error: (
          error
        ) => {

          console.error(
            'Unable to load qualification list:',
            error
          );


          // Reset qualification list
          this.qualificationList =
            [];
        }

      });
  }


  // Handle education qualification change
  onEducationQualificationChange(
    qualificationId:
      number | null
  ): void {

    // Reset qualification details
    if (
      !qualificationId
    ) {

      this.participant
        .qualificationId =
        null;


      this.participant
        .qualificationName =
        '';


      this.participant
        .qualificationType =
        '';


      return;
    }


    // Find selected qualification
    const selectedQualification =
      this.qualificationList
        .find(
          qualification =>
            Number(
              qualification.id
            ) ===
            Number(
              qualificationId
            )
        );


    // Handle missing qualification
    if (
      !selectedQualification
    ) {

      this.participant
        .qualificationId =
        null;


      this.participant
        .qualificationName =
        '';


      this.participant
        .qualificationType =
        '';


      return;
    }


    // Store qualification ID
    this.participant
      .qualificationId =
      selectedQualification.id;


    // Store qualification name
    this.participant
      .qualificationName =
      selectedQualification
        .qualificationName;


    // Store qualification type
    this.participant
      .qualificationType =
      selectedQualification
        .qualificationType;
  }


  // Check VOC only selection
  get isOnlyVOC(): boolean {

    // Check selected courses
    if (
      !this.selectedCourses.length
    ) {

      return false;
    }


    // Check all courses are VOC
    return this.selectedCourses
      .every(
        course =>
          (
            course.courseType
            ?? ''
          )
            .toUpperCase() ===
          'VOC'
      );
  }


  // Check USI visibility
  get showUSI(): boolean {

    // VOC-only registration does not show USI
    return !this.isOnlyVOC;
  }


  // Load participant details
  loadParticipantDetails(): void {

    // Start loading
    this.isLoading =
      true;


    // Reset messages
    this.errorMessage =
      '';

    this.loadErrorMessage =
      '';

    this.successMessage =
      '';

    this.alreadySubmitted =
      false;


    this.adminService
      .GetXParticipantDetails(
        this.enquiryId,
        this.participantId,
        this.type
      )
      .subscribe({

        next: (
          response: any
        ) => {

          // Stop loading
          this.isLoading =
            false;


          // Check participant response
          if (
            !response
          ) {

            this.loadErrorMessage =
              'Participant registration details were not found.';

            return;
          }


          // Populate participant details
          this.populateParticipantDetails(
            response
          );
        },


        error: (
          error
        ) => {

          console.error(
            'Unable to load participant details:',
            error
          );


          // Stop loading
          this.isLoading =
            false;


          // Handle not found response
          if (
            error?.status ===
            404
          ) {

            this.loadErrorMessage =
              'Participant registration details were not found.';

            return;
          }


          // Store load error
          this.loadErrorMessage =
            typeof error?.error ===
              'string'
              ? error.error
              : 'Unable to load participant registration details.';
        }

      });
  }


  // Populate participant details
  private populateParticipantDetails(
    response: any
  ): void {

    console.log(response);

    // Store company name
    this.companyName =
      response?.companyName
      ??
      response?.CompanyName
      ??
      '';

    // Store company email
    this.companyEmail =
      response?.companyEmail
      ??
      response?.companyEmail
      ??
      '';


    // Store training required date
    this.dateTrainingRequired =
      response?.dateTrainingRequired
      ??
      response?.DateTrainingRequired
      ??
      null;


    // Store participant number
    const participantNo =
      Number(
        response?.participantNo
        ??
        response?.ParticipantNo
        ??
        this.participantId
      );


    // Store participant name
    const participantName =
      (
        response?.participantName
        ??
        response?.ParticipantName
        ??
        ''
      )
        .toString()
        .trim();

    // Store participant email
    const participantEmail =
      (
        response?.participantEmail
        ??
        response?.participantEmail
        ??
        ''
      )
        .toString()
        .trim();


    // Store participant mobile number
    const participantMobileNumber =
      (
        response?.participantMobileNumber
        ??
        response?.participantMobileNumber
        ??
        ''
      )
        .toString()
        .trim();


    // Store selected courses
    this.selectedCourses =
      this.parseSelectedCourses(
        response?.selectedCourses
        ??
        response?.SelectedCourses
      );


    // Split participant name
    const name =
      this.splitFullName(
        participantName
      );


    // Create participant details
    this.participant =
      this.createParticipant({

        participantNo:
          participantNo,

        fullName:
          participantName,

        firstName:
          name.firstName,

        lastName:
          name.lastName,

        selectedCourses:
          this.selectedCourses,

        emailAddress: participantEmail,
        mobileNumber: participantMobileNumber

      });


    // Clear USI for VOC only
    if (
      this.isOnlyVOC
    ) {

      this.participant
        .usi =
        '';
    }
  }


  // Parse selected courses
  private parseSelectedCourses(
    value: any
  ): XSelectedCourse[] {

    // Check selected course value
    if (
      !value
    ) {

      return [];
    }


    // Store parsed course source
    let source:
      any[] =
      [];


    try {

      // Parse selected courses
      source =
        Array.isArray(
          value
        )
          ? value
          : JSON.parse(
            value.toString()
          );

    }
    catch (
    error
    ) {

      console.error(
        'Unable to parse selected courses:',
        error
      );


      return [];
    }


    // Validate parsed course list
    if (
      !Array.isArray(
        source
      )
    ) {

      return [];
    }


    // Map selected courses
    return source.map(
      (
        course: any
      ) => {

        return {

          courseType:
            (
              course?.courseType
              ??
              course?.CourseType
              ??
              ''
            )
              .toString()
              .trim()
              .toUpperCase(),


          slot:
            this.toNullableNumber(
              course?.slot
              ??
              course?.Slot
            ),


          courseId:
            this.toNullableNumber(
              course?.courseId
              ??
              course?.CourseId
            ),


          courseCode:
            course?.courseCode
            ??
            course?.CourseCode
            ??
            '',


          courseName:
            course?.courseName
            ??
            course?.CourseName
            ??
            '',


          description:
            course?.description
            ??
            course?.Description
            ??
            '',


          totalAmount:
            this.toNullableNumber(
              course?.totalAmount
              ??
              course?.TotalAmount
            ),


          currencyCode:
            course?.currencyCode
            ??
            course?.CurrencyCode
            ??
            '',


          documentTypes:
            course?.documentTypes
            ??
            course?.DocumentTypes
            ??
            ''
        };
      }
    );
  }


  // Convert value to nullable number
  private toNullableNumber(
    value: any
  ): number | null {

    // Check empty value
    if (
      value ===
      null
      ||
      value ===
      undefined
      ||
      value ===
      ''
    ) {

      return null;
    }


    // Convert value to number
    const numberValue =
      Number(
        value
      );


    // Return valid number
    return Number.isNaN(
      numberValue
    )
      ? null
      : numberValue;
  }


  // Create participant
  private createParticipant(
    values:
      Partial<XParticipantRegistrationForm> =
      {}
  ): XParticipantRegistrationForm {

    return {

      // Store participant number
      participantNo:
        values.participantNo
        ??
        0,

      // Store full name
      fullName:
        values.fullName
        ??
        '',


      // Store first name
      firstName:
        values.firstName
        ??
        '',

      // Store last name
      lastName:
        values.lastName
        ??
        '',

      // Store date of birth
      dateOfBirth:
        values.dateOfBirth
        ??
        '',

      // Store address
      address:
        values.address
        ??
        '',

      // Store email address
      emailAddress:
        values.emailAddress
        ??
        '',

      // Store mobile number
      mobileNumber:
        values.mobileNumber
        ??
        '',


      // Store qualification ID
      qualificationId:
        values.qualificationId
        ??
        null,

      // Store qualification name
      qualificationName:
        values.qualificationName
        ??
        '',

      // Store qualification type
      qualificationType:
        values.qualificationType
        ??
        '',

      // Store USI
      usi:
        values.usi
        ??
        '',


      // Store relevant qualification
      relevantQualification:
        values.relevantQualification
        ??
        '',

      // Store certificate number
      qualificationCertificateNumber:
        values.qualificationCertificateNumber
        ??
        '',

      // Store issuing organisation
      issuingOrganisation:
        values.issuingOrganisation
        ??
        '',

      // Store issued or expiry date
      dateIssuedExpiry:
        values.dateIssuedExpiry
        ??
        '',

      // Store certificate availability
      certificateAvailable:
        values.certificateAvailable
        ??
        null,


      // Store certificates
      certificates:
        values.certificates
        ??
        [],


      // Track certificate upload state
      isCertificateUploading:
        values.isCertificateUploading
        ??
        false,

      // Store certificate upload error
      certificateUploadError:
        values.certificateUploadError
        ??
        '',


      // Store identity documents
      identities:
        values.identities
        ??
        [
          this.createIdentity()
        ],


      // Store selected courses
      selectedCourses:
        values.selectedCourses
        ??
        []
    };
  }


  // Create identity document
  private createIdentity():
    XIdentityDocument {

    return {

      // Store identity type
      idType:
        '',

      // Store identity number
      idNumber:
        '',

      // Store expiry date
      expiryDate:
        '',

      // Store nationality
      nationality:
        '',


      // Store file name
      fileName:
        '',

      // Store file URL
      fileUrl:
        '',

      // Store file type
      fileType:
        '',


      // Track upload state
      isUploading:
        false,

      // Store upload error
      uploadError:
        '',


      // Track reading state
      isReading:
        false,

      // Store OCR progress
      ocrProgress:
        0
    };
  }


  // Add identity document
  addIdentity(): void {

    this.participant
      .identities
      .push(
        this.createIdentity()
      );
  }


  // Remove identity document
  removeIdentity(
    index: number
  ): void {

    // Keep at least one identity
    if (
      this.participant
        .identities
        .length <=
      1
    ) {

      return;
    }


    // Remove identity
    this.participant
      .identities
      .splice(
        index,
        1
      );
  }


  // Split full name
  private splitFullName(
    fullName: string
  ): {

    firstName: string;

    lastName: string;

  } {

    // Store trimmed name
    const value =
      fullName
        ?.trim()
      ??
      '';


    // Handle empty name
    if (
      !value
    ) {

      return {

        firstName:
          '',

        lastName:
          ''
      };
    }


    // Split name parts
    const parts =
      value.split(
        /\s+/
      );


    // Return first and last name
    return {

      firstName:
        parts[0]
        ??
        '',

      lastName:
        parts
          .slice(
            1
          )
          .join(
            ' '
          )
    };
  }


  // Get training date display
  getTrainingDateDisplay():
    string {

    // Check training date
    if (
      !this.dateTrainingRequired
    ) {

      return '-';
    }


    // Convert training date
    const date =
      new Date(
        this.dateTrainingRequired
      );


    // Handle invalid date
    if (
      Number.isNaN(
        date.getTime()
      )
    ) {

      return this
        .dateTrainingRequired;
    }


    // Return formatted training date
    return date.toLocaleDateString(
      'en-AU',
      {

        day:
          '2-digit',

        month:
          '2-digit',

        year:
          'numeric'
      }
    );
  }


  // Handle certificate availability change
  onCertificateAvailableChange():
    void {

    // Clear certificates when unavailable
    if (
      this.participant
        .certificateAvailable !==
      true
    ) {

      this.participant
        .certificates =
        [];


      this.participant
        .certificateUploadError =
        '';
    }
  }


  // Handle certificate file selection
  /* onCertificateFilesSelected(
    event: Event
  ): void {

    // Get file input
    const input =
      event.target as
      HTMLInputElement;


    // Store selected files
    const files =
      Array.from(
        input.files
        ??
        []
      );


    // Reset certificate upload error
    this.participant
      .certificateUploadError =
      '';


    // Check selected files
    if (
      !files.length
    ) {

      return;
    }


    // Process selected files
    files.forEach(
      file => {

        // Validate file
        const validationError =
          this.getUploadValidationError(
            file
          );


        if (
          validationError
        ) {

          this.participant
            .certificateUploadError =
            validationError;

          return;
        }


        // Upload certificate
        this.uploadCertificate(
          file
        );
      }
    );


    // Reset file input
    input.value =
      '';
  } */
onCertificateFilesSelected(event: Event): void {

  // Get file input
  const input = event.target as HTMLInputElement;

  // Store selected files
  const files = Array.from(input.files ?? []);

  // Reset certificate upload error
  this.participant.certificateUploadError = '';

  // Check selected files
  if (!files.length) {
    return;
  }

  // Maximum file size: 3 MB
  const maxFileSize = 3 * 1024 * 1024;

  // Process selected files
  files.forEach(file => {

    // Validate file size
    if (file.size > maxFileSize) {

      this.participant.certificateUploadError =
        `File "${file.name}" exceeds the 3 MB limit.`;

      return;
    }

    // Validate file
    const validationError =
      this.getUploadValidationError(file);

    if (validationError) {

      this.participant.certificateUploadError =
        validationError;

      return;
    }

    // Upload certificate
    this.uploadCertificate(file);

  });

  // Reset file input
  input.value = '';
}

  // Upload certificate
  private uploadCertificate(
    file: File
  ): void {

    // Increase upload count
    this.certificateUploadingCount++;


    // Mark certificate upload state
    this.participant
      .isCertificateUploading =
      true;


    this.uploadService
      .uploadSingleFile(
        file,
        'certificate-doc'
      )
      .subscribe({

        next: (
          response: any
        ) => {

          // Store uploaded file URL
          const uploadedUrl = response?.publicUrl ?? '';


          // Check uploaded URL
          if (
            !uploadedUrl
          ) {

            this.participant
              .certificateUploadError =
              `The file ${file.name} was uploaded, but the file URL was not returned.`;

            this.finishCertificateUpload();

            return;
          }


          // Store uploaded certificate
          this.participant
            .certificates
            .push({

              fileName:
                file.name,

              fileUrl:
                uploadedUrl,

              fileType:
                file.type
            });


          // Finish certificate upload
          this.finishCertificateUpload();
        },


        error: (
          error
        ) => {

          console.error(
            'Certificate upload failed:',
            error
          );


          // Store certificate upload error
          this.participant
            .certificateUploadError =
            `Unable to upload ${file.name}. Please try again.`;


          // Finish certificate upload
          this.finishCertificateUpload();
        }

      });
  }


  // Finish certificate upload
  private finishCertificateUpload():
    void {

    // Decrease upload count
    this.certificateUploadingCount =
      Math.max(
        0,
        this.certificateUploadingCount - 1
      );


    // Update certificate upload state
    this.participant
      .isCertificateUploading =
      this.certificateUploadingCount >
      0;
  }


  // Remove certificate
  removeCertificate(
    index: number
  ): void {

    this.participant
      .certificates
      .splice(
        index,
        1
      );
  }


  // Handle ID file selection
  onIdFileSelected(
    event: Event,
    identityIndex: number
  ): void {

    // Get file input
    const input =
      event.target as
      HTMLInputElement;


    // Store selected file
    const file =
      input.files?.[0];


    // Get selected identity
    const identity =
      this.participant
        .identities[
      identityIndex
      ];

      

    // Validate identity
    if (
      !identity
    ) {

      return;
    }

// Maximum allowed file size: 3 MB
const maxFileSize = 3 * 1024 * 1024; // 3 MB

if (file.size > maxFileSize) {
  identity.uploadError =
    'File size must not exceed 3 MB. Please select a smaller file.';

  input.value = '';
  return;
}
    // Reset upload error
    identity.uploadError =
      '';


    // Validate identity type
    if (
      !identity.idType
    ) {

      identity.uploadError =
        'Please select an ID type first.';


      input.value =
        '';


      return;
    }


    // Check selected file
    if (
      !file
    ) {

      return;
    }


    // Validate file
    const validationError =
      this.getUploadValidationError(
        file
      );


    if (
      validationError
    ) {

      identity.uploadError =
        validationError;


      input.value =
        '';


      return;
    }


    // Store file name
    identity.fileName =
      file.name;


    // Store file type
    identity.fileType =
      file.type;


    // Reset file URL
    identity.fileUrl =
      '';


    // Check OCR supported image
    const isImage =
      file.type ===
      'image/jpeg'
      ||
      file.type ===
      'image/png'
      ||
      file.type ===
      'image/webp';


    if (
      isImage
      &&
      (
        identity.idType ===
        'DRIVER_LICENCE'
        ||
        identity.idType ===
        'PASSPORT'
      )
    ) {

      /* this.readIdDocument(
        file,
        identityIndex
      ); */
    }


    // Start identity upload
    identity.isUploading =
      true;


    this.uploadService
      .uploadSingleFile(
        file,
        'identity-doc'
      )
      .subscribe({

        next: (
          response: any
        ) => {

          // Stop identity upload
          identity.isUploading =
            false;


          // Store uploaded file URL
          const uploadedUrl = response?.publicUrl ?? '';


          // Check uploaded URL
          if (
            !uploadedUrl
          ) {

            identity.uploadError =
              'The file was uploaded, but the file URL was not returned.';

            return;
          }


          // Store uploaded file URL
          identity.fileUrl =
            uploadedUrl;
        },


        error: (
          error
        ) => {

          console.error(
            'ID document upload failed:',
            error
          );


          // Stop identity upload
          identity.isUploading =
            false;


          // Store upload error
          identity.uploadError =
            'File upload failed. Please try again.';


          // Reset file details
          identity.fileName =
            '';


          identity.fileUrl =
            '';


          identity.fileType =
            '';


          input.value =
            '';
        }

      });
  }


  // Remove ID file
  removeIdFile(
    identityIndex: number
  ): void {

    // Get selected identity
    const identity =
      this.participant
        .identities[
      identityIndex
      ];


    // Validate identity
    if (
      !identity
    ) {

      return;
    }


    // Reset file details
    identity.fileName =
      '';


    identity.fileUrl =
      '';


    identity.fileType =
      '';


    identity.uploadError =
      '';
  }


  // Validate upload file
  private getUploadValidationError(
    file: File
  ): string {

    // Store allowed MIME types
    const allowedMimeTypes = [

      'application/pdf',

      'image/jpeg',

      'image/png',

      'image/webp'
    ];


    // Store allowed file extensions
    const allowedExtensions = [

      '.pdf',

      '.jpg',

      '.jpeg',

      '.png',

      '.webp'
    ];


    // Store lowercase file name
    const fileName =
      file.name
        .toLowerCase();


    // Check valid extension
    const hasValidExtension =
      allowedExtensions
        .some(
          extension =>
            fileName.endsWith(
              extension
            )
        );


    // Check valid MIME type
    const hasValidMimeType =
      allowedMimeTypes
        .includes(
          file.type
        );


    // Validate file type
    if (
      !hasValidMimeType
      &&
      !hasValidExtension
    ) {

      return 'Please upload a PDF, JPG, JPEG, PNG or WebP file.';
    }


    // Store maximum file size
    const maximumFileSize =
      10 *
      1024 *
      1024;


    // Validate file size
    if (
      file.size >
      maximumFileSize
    ) {

      return 'The file must be smaller than 10 MB.';
    }


    return '';
  }


  // Check uploading files
  hasUploadingFiles():
    boolean {

    // Check identity uploads
    const identityUploading =
      this.participant
        .identities
        .some(
          identity =>
            identity.isUploading
            ||
            identity.isReading
        );


    // Return upload state
    return (

      this.participant
        .isCertificateUploading

      ||

      identityUploading
    );
  }
  // Validate registration form
  validateForm():
    boolean {

    // Reset error message
    this.errorMessage =
      '';


    // Validate first name
    if (
      !this.participant
        .firstName
        ?.trim()
    ) {

      this.errorMessage =
        'First name is required.';

      return false;
    }


    // Validate last name
    if (
      !this.participant
        .lastName
        ?.trim()
    ) {

      this.errorMessage =
        'Last name is required.';

      return false;
    }


    // Validate email address
    if (
      !this.participant
        .emailAddress
        ?.trim()
    ) {

      this.errorMessage =
        'Email address is required.';

      return false;
    }


    // Validate mobile number
    if (
      !this.participant
        .mobileNumber
        ?.trim()
    ) {

      this.errorMessage =
        'Mobile No is required.';

      return false;
    }


    // Validate certificate upload
    if (
      this.participant
        .certificateAvailable ===
      true
      &&
      this.participant
        .certificates
        .length ===
      0
    ) {

      this.errorMessage =
        'Please upload at least one qualification certificate.';

      return false;
    }


    // Check pending uploads
    if (
      this.hasUploadingFiles()
    ) {

      this.errorMessage =
        'Please wait until all documents have finished uploading.';

      return false;
    }


    return true;
  }


  // Build registration data
  buildRegistrationData(): any {

    // Store UOC courses
    const uocCourses =
      this.selectedCourses
        .filter(
          course =>
            course.courseType ===
            'UOC'
        )
        .map(
          course => ({

            slot:
              course.slot,

            courseId:
              course.courseId,

            courseCode:
              course.courseCode,

            courseTitle:
              course.courseName,

            description:
              course.description,

            totalAmount:
              course.totalAmount,

            currencyCode:
              course.currencyCode,

            documentTypes:
              course.documentTypes

          })
        );


    // Store VOC courses
    const vocCourses =
      this.selectedCourses
        .filter(
          course =>
            course.courseType ===
            'VOC'
        )
        .map(
          course => ({

            slot:
              course.slot,

            vocId:
              course.courseId,

            vocCode:
              course.courseCode,

            vocName:
              course.courseName,

            description:
              course.description,

            documentTypes:
              course.documentTypes

          })
        );


    // Store COA courses
    const coaCourses =
      this.selectedCourses
        .filter(
          course =>
            course.courseType ===
            'COA'
        )
        .map(
          course => ({

            slot:
              course.slot,

            courseName:
              course.courseName

          })
        );


    // Build registration body
    return {

      enquiryId:
        this.enquiryId,


      participantId:
        this.participantId,


      // Store enquiry details
      enquiryDetails: {

        clientType:
          this.type?.toLowerCase() === 'enq'
            ? 'GENERAL'
            : 'CORPORATE',


        clientDetails: {

          companyName: this.companyName,

          dateTrainingRequired: this.dateTrainingRequired,

          companyEmail: this.companyEmail
        }
      },


      // Store company details
      companyDetails: {

        companyName: this.companyName,
        companyEmail: this.companyEmail
      },


      // Store participant registrations
      participantRegistrations: [

        {

          participantNo:
            this.participant
              .participantNo,


          firstName:
            this.participant
              .firstName
              ?.trim()
            ??
            '',


          lastName:
            this.participant
              .lastName
              ?.trim()
            ??
            '',


          dateOfBirth:
            this.participant
              .dateOfBirth
            ||
            null,


          address:
            this.participant
              .address
              ?.trim()
            ??
            '',


          emailAddress:
            this.participant
              .emailAddress
              ?.trim()
            ??
            '',


          mobileNumber:
            this.participant
              .mobileNumber
              ?.trim()
            ??
            '',


          uocCourses:
            uocCourses,


          vocCourses:
            vocCourses,


          coaCourses:
            coaCourses,


          // Store education details
          education: {

            qualificationId:
              this.participant
                .qualificationId,

            qualificationName:
              this.participant
                .qualificationName
                ?.trim()
              ??
              '',

            qualificationType:
              this.participant
                .qualificationType
                ?.trim()
              ??
              '',

            usi:
              this.showUSI
                ? (
                  this.participant
                    .usi
                    ?.trim()
                  ??
                  ''
                )
                : ''
          },


          // Store qualification details
          qualification: {

            qualificationId:
              this.participant
                .qualificationId,

            qualificationName:
              this.participant
                .qualificationName
                ?.trim()
              ??
              '',

            qualificationType:
              this.participant
                .qualificationType
                ?.trim()
              ??
              '',


            relevantQualification:
              this.participant
                .relevantQualification
                ?.trim()
              ??
              '',


            qualificationCertificateNumber:
              this.participant
                .qualificationCertificateNumber
                ?.trim()
              ??
              '',


            issuingOrganisation:
              this.participant
                .issuingOrganisation
                ?.trim()
              ??
              '',


            dateIssuedExpiry:
              this.participant
                .dateIssuedExpiry
              ||
              '',


            certificateAvailable:
              this.participant
                .certificateAvailable,


            // Store qualification certificates
            certificates:
              this.participant
                .certificates
                .map(
                  certificate => ({

                    fileName:
                      certificate.fileName,

                    fileUrl:
                      certificate.fileUrl,

                    fileType:
                      certificate.fileType
                  })
                )
          },


          // Store identity documents
          identities:
            this.participant
              .identities
              .map(
                identity => ({

                  idType:
                    identity.idType,


                  idNumber:
                    identity
                      .idNumber
                      ?.trim()
                    ??
                    '',


                  expiryDate:
                    identity
                      .expiryDate
                    ||
                    null,


                  nationality:
                    identity
                      .nationality
                      ?.trim()
                    ??
                    '',


                  idFileName:
                    identity.fileName,


                  idFileUrl:
                    identity.fileUrl,


                  idFileType:
                    identity.fileType

                })
              )
        }
      ],


      submittedDate:
        this.submittedDate
    };
  }


  // Submit registration
  submitRegistration():
    void {

    // Reset success message
    this.successMessage =
      '';


    // Reset error message
    this.errorMessage =
      '';


    // Validate registration form
    if (
      !this.validateForm()
    ) {

      return;
    }



    // Build registration data
    const registrationData = this.buildRegistrationData();

    // Start submission
    this.isSubmitting = true;


    // Save booking registration
    this.saveBookingRegistration(registrationData);
  }


  // Save booking registration
  saveBookingRegistration(registrationData: any) {

    this.adminService
      .SaveXBookingRegistration(
        this.enquiryId,
        registrationData
      )
      .subscribe({

        next: (
          response: number
        ) => {

          // Stop submission
          this.isSubmitting = false;

          // Handle successful registration
          if (response && response > 0) {

            this.successMessage =
              'Registration details submitted successfully.';

            //  Show success popup
            this.showSuccessPopup = true;


            return;
          }

          // Store registration error
          this.errorMessage =
            'Unable to submit registration details.';
        },

        error: (
          error
        ) => {

          console.error(
            'Registration save error:',
            error
          );

          // Stop submission
          this.isSubmitting = false;

          // Store registration error
          this.errorMessage =
            typeof error?.error ===
              'string'
              ? error.error
              : 'Unable to submit registration details.';
        }

      });
  }


  // Save enquiry registration
  saveEnqRegistration(registrationData: any) {

    this.adminService
      .saveXEnquiryRegistration(
        this.enquiryId,
        registrationData
      )
      .subscribe({

        next: (
          response: number
        ) => {

          // Stop submission
          this.isSubmitting = false;

          // Handle successful registration
          if (response && response > 0) {

            this.successMessage =
              'Registration details submitted successfully.';

            //  Show success popup
            this.showSuccessPopup = true;



            return;
          }

          // Store registration error
          this.errorMessage =
            'Unable to submit registration details.';
        },

        error: (
          error
        ) => {

          console.error(
            'Registration save error:',
            error
          );

          // Stop submission
          this.isSubmitting = false;

          // Store registration error
          this.errorMessage =
            typeof error?.error ===
              'string'
              ? error.error
              : 'Unable to submit registration details.';
        }

      });
  }


  // Close enquiry success popup
  closeEnquirySuccessPopup(): void {

    // Hide success popup
    this.showSuccessPopup = false;

    // Navigate to home page
    this.router.navigate(['/']);
  }





}